"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[963],{

/***/ 98521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CouponsAndVouchers_PromoSlider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/BasicSlider/index.tsx + 2 modules
var BasicSlider = __webpack_require__(9997);
// EXTERNAL MODULE: ./src/assets/svgExports/OfferIcon.js
var OfferIcon = __webpack_require__(93757);
// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(13508);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/Common/index.tsx
var Common = __webpack_require__(92134);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/redux/actions/promo.js
var promo = __webpack_require__(68615);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/PromoSlide/index.tsx






var PromoSlide = function(param) {
    var promoData = param.promoData;
    var openProductDetailsModal = function openProductDetailsModal() {
        dispatch((0,promo/* togglePromoDetailModal */.wl)({
            show: true,
            promoId: promoData === null || promoData === void 0 ? void 0 : promoData.id
        }));
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var offerIconSize = checkClientDeviceType/* IS_DESKTOP */.yn ? 15 : 12;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "!tw-flex tw-items-start tw-justify-between tw-border tw-border-solid tw-border-[#E3E3E3] tw-px-[16px] tw-py-[12px] md:tw-items-center md:tw-px-[24px] md:tw-py-[16px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-gap-[2px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-m-0 tw-text-[12px]/[20px] md:tw-text-[15px]/[20px]",
                        children: "Special Offer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-m-0 tw-flex tw-gap-[4px] md:tw-gap-[8px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tw-mt-[4px] tw-flex md:tw-mt-[2.5px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferIcon/* default */.Z, {
                                    height: offerIconSize,
                                    width: offerIconSize
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "tw-m-0 tw-text-[12px]/[20px] tw-font-semibold md:tw-text-[16px]/[20px]",
                                        children: promoData === null || promoData === void 0 ? void 0 : promoData.description
                                    }),
                                    !checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "tw-m-0 tw-text-[11px]/[20px] tw-text-[#575757]",
                                        children: [
                                            "Use Code - ",
                                            promoData === null || promoData === void 0 ? void 0 : promoData.code
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-gap-[24px]",
                children: [
                    checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-border tw-border-dashed tw-px-[12px] tw-py-[8px] tw-text-[14px]/[20px] tw-font-semibold",
                        children: [
                            "Use Code - ",
                            promoData === null || promoData === void 0 ? void 0 : promoData.code
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Common/* StripCTA */.iQ, {
                        onClick: openProductDetailsModal
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CouponsAndVouchers_PromoSlide = (PromoSlide);

// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.js
var useFeatureLocks = __webpack_require__(27560);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/PromoSlider/index.tsx








var PromoSlider = function(param) {
    var type = param.type, typeId = param.typeId, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses, _setPromosDataToParent = param.setPromosDataToParent, setPromosDataToParent = _setPromosDataToParent === void 0 ? null : _setPromosDataToParent;
    var getSliderPromos = function getSliderPromos() {
        typeId = Number(typeId);
        if (isNaN(typeId) || typeId < 0) {
            return;
        }
        var data = {
            type: type,
            type_ids: [
                typeId
            ],
            store_id: storeId,
            user_id: userId
        };
        dispatch((0,promo/* getPromosByTypeAndTypeId */.Lr)(data, function(data) {
            setPromosDataToParent(data);
            setPromosData(data);
        }));
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)([]), promosData = ref[0], setPromosData = ref[1];
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return {
            storeId: state.storeReducer.store.store_id,
            userId: ((ref = state.userReducer.data) === null || ref === void 0 ? void 0 : ref.user_id) || 0
        };
    }), storeId = ref1.storeId, userId = ref1.userId;
    var couponsFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().couponsFeatureStatus;
    var isCouponsFeatureLocked = !!(couponsFeatureStatus === null || couponsFeatureStatus === void 0 ? void 0 : couponsFeatureStatus.isLocked);
    (0,react.useEffect)(function() {
        if (type && typeId >= 0 && !isCouponsFeatureLocked) {
            getSliderPromos();
        }
    }, []);
    return !!(promosData === null || promosData === void 0 ? void 0 : promosData.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-w-full ".concat(checkClientDeviceType/* IS_DESKTOP */.yn ? "tw-mb-[24px]" : "tw-mb-[36px]", " ").concat(customClasses),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicSlider/* default */.Z, {
            showArrows: checkClientDeviceType/* IS_DESKTOP */.yn && (promosData === null || promosData === void 0 ? void 0 : promosData.length) > 1,
            showDots: !checkClientDeviceType/* IS_DESKTOP */.yn,
            children: promosData.map(function(promoData, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponsAndVouchers_PromoSlide, {
                    promoData: promoData
                }, index);
            })
        })
    });
};
/* harmony default export */ var CouponsAndVouchers_PromoSlider = (PromoSlider);


/***/ }),

/***/ 93992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DigitalShowroomAds_ReasonModalHOC; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/utils/useClosePopupFromOutsideClick.js

function useClosePopupFromOutsideClick(referenceToDomElement, toggleClose, props) {
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var handleClickOutside = function(e) {
        var ref;
        if (!((ref = e.composedPath()) === null || ref === void 0 ? void 0 : ref.includes(referenceToDomElement.current))) {
            e.stopPropagation();
            toggleClose(props === null || props === void 0 ? void 0 : props.id, props === null || props === void 0 ? void 0 : props.toggleStatus);
        }
    };
}
/* harmony default export */ var utils_useClosePopupFromOutsideClick = (useClosePopupFromOutsideClick);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/DigitalShowroomAds/ReasonModal.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 0;\n  width: 20px;\n  margin-left: ",
        "rem;\n  transform: rotateZ(180deg);\n  margin-top: ",
        "rem;\n  box-shadow: 0px -6px 12px 2px rgb(0 0 0 / 30%);\n  ",
        ";\n\n  &:before {\n    content: '';\n    border-top: 10px solid white;\n    border-right: 10px solid transparent;\n    border-left: 10px solid transparent;\n    border-bottom: 10px solid transparent;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var PointingArrow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PointingArrow",
    componentId: "sc-6444d3ae-0"
})(_templateObject(), function(props) {
    return props.ml || 0;
}, function(props) {
    return props.mt || 0;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.translateX) && (props === null || props === void 0 ? void 0 : props.translateY) && "transform : translate(".concat(props === null || props === void 0 ? void 0 : props.translateX, "rem , ").concat(props === null || props === void 0 ? void 0 : props.translateY, "rem) rotate(180deg)");
});

;// CONCATENATED MODULE: ./src/components/DesignSystem/DigitalShowroomAds/ReasonModalHOC.js





function ReasonModalHOC(props) {
    var elementReferenceForOutsideClick = (0,react.useRef)();
    var closePopupForParticularId = {
        id: props.id,
        toggleStatus: false
    };
    utils_useClosePopupFromOutsideClick(elementReferenceForOutsideClick, props.toggleAdReasonModal, closePopupForParticularId);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PointingArrow, {
                ml: props.ml,
                translateX: props.translateX,
                translateY: props.translateY,
                mt: props.mt
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    zIndex: 1
                },
                ref: elementReferenceForOutsideClick,
                className: props.class,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(props.reasonModal, {})
            })
        ]
    });
}
/* harmony default export */ var DigitalShowroomAds_ReasonModalHOC = (ReasonModalHOC);


/***/ }),

/***/ 40237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bv": function() { return /* binding */ FilterDrawerMobileCta; },
/* harmony export */   "E": function() { return /* binding */ ListingHeading; },
/* harmony export */   "GW": function() { return /* binding */ PromoSliderContainer; },
/* harmony export */   "Ne": function() { return /* binding */ AdWidgetContainer; },
/* harmony export */   "UT": function() { return /* binding */ FilterDrawerMobileCtaContainer; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "X6": function() { return /* binding */ Heading; },
/* harmony export */   "Y$": function() { return /* binding */ FilterDrawerWrapper; },
/* harmony export */   "ef": function() { return /* binding */ FilterDrawerMobileCtaApply; }
/* harmony export */ });
/* unused harmony export Listing */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45726);
/* harmony import */ var _utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13508);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13886);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50066);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        ";\n  width: 90%;\n  max-width: 1600px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  box-sizing: border-box;\n  @media screen and (max-width: 767px) {\n    padding-top: 0;\n    width: 100vw;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  width: 100%;\n  font-size: 40px;\n  color: ",
        ";\n\n  @media screen and (min-width: 767px) {\n    font-size: 40px;\n    margin-bottom: 3rem;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 28px;\n    margin-bottom: 2rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 1000px;\n  display: grid;\n  grid-template-rows: auto;\n  justify-items: center;\n  box-sizing: border-box;\n\n  @media screen and (min-width: 767px) {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    row-gap: 2rem;\n    column-gap: 1.5rem;\n    padding: 0 2rem;\n  }\n\n  @media screen and (max-width: 766px) {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    row-gap: 1.5rem;\n    column-gap: 1rem;\n    padding: 0 1rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 1000px;\n  padding: 0 2rem;\n  margin-top: 20px;\n  margin-bottom: 38px;\n\n  @media screen and (max-width: 766px) {\n    padding: 0 1rem;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #000000;\n  font-weight: 600;\n  margin-bottom: 0.8rem;\n  scroll-margin: 50px 0 0 0;\n\n  @media screen and (min-width: 767px) {\n    font-size: 28px;\n    padding: 0 2rem;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 20px;\n    padding: 0 1rem;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  border-right: 1px solid #eaeaea;\n  position: sticky;\n  height: 100vh;\n  width: 300px;\n  display: ",
        ";\n  @media screen and (max-width: ",
        "px) {\n    width: 100vw;\n    top: 0px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  all: unset;\n  display: flex;\n  position: absolute;\n  bottom: 0%;\n  height: 48px;\n  width: 100vw;\n  justify-content: center;\n  align-itemns: center;\n  background: white;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  all: unset;\n  display: flex;\n  height: 48px;\n  width: 50vw;\n  justify-content: center;\n  align-items: center;\n  background: white;\n  border: 1px solid #e2e2e2;\n  :last-child {\n    border-left: none;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  all: unset;\n  display: flex;\n  height: 48px;\n  width: 50vw;\n  justify-content: center;\n  align-items: center;\n  background: white;\n  border: 1px solid #e2e2e2;\n  background: ",
        ";\n  color: #fff;\n  :last-child {\n    border-left: none;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
var ref, ref1;




var storeInfo = _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getState */ .Z.getState().storeReducer.store;
function slideInAnimate() {
    return "\n    animation-name: slide-in;\n    animation-duration: 0.5s;\n    transform : translateX(50px);\n\n    @keyframes slide-in {\n      from {\n          transform : translateX(0px);\n      }\n      to {\n          transform : translateX(50px);\n      }\n    }\n    ";
}
function slideOutAnimate(trasnlationDist) {
    return "\n    animation-name: slide-out;\n    animation-duration: 0.50s;\n\n    @keyframes slide-out {\n      from {\n          transform : translateX(0px);\n      }\n      to {\n         transform : translateX(".concat(trasnlationDist + 58, "px);\n      }\n    }\n    ");
}
var Container = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].article.withConfig */ .ZP.article.withConfig({
    displayName: "Container",
    componentId: "sc-175c9e83-0"
})(_templateObject(), function(props) {
    return props.isBuilderMobile ? "4rem 16px 2rem" : "4rem 0 2rem";
});
var Heading = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    displayName: "Heading",
    componentId: "sc-175c9e83-1"
})(_templateObject1(), function(props) {
    return props.fontColor || "#000000";
});
var Listing = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "Listing",
    componentId: "sc-175c9e83-2"
})(_templateObject2());
var PromoSliderContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "PromoSliderContainer",
    componentId: "sc-175c9e83-3"
})(_templateObject3());
var ListingHeading = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    displayName: "ListingHeading",
    componentId: "sc-175c9e83-4"
})(_templateObject4());
var AdWidgetContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AdWidgetContainer",
    componentId: "sc-175c9e83-5"
})(_templateObject5(), function(props) {
    return props.showFilterDrawer && _utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_2__/* .IS_MOBILE */ .q$ ? "overflow: hidden" : "overflow: auto";
}, function(props) {
    return props.showFilterDrawer === null ? "" : props.showFilterDrawer ? slideInAnimate() : slideOutAnimate(props.trasnlationDist);
});
var FilterDrawerWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FilterDrawerWrapper",
    componentId: "sc-175c9e83-6"
})(_templateObject6(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.showFilterDrawer) ? "unset" : "none";
}, _utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .MAX_MOBILE_WIDTH */ .Cf);
var FilterDrawerMobileCtaContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FilterDrawerMobileCtaContainer",
    componentId: "sc-175c9e83-7"
})(_templateObject7());
var FilterDrawerMobileCta = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "FilterDrawerMobileCta",
    componentId: "sc-175c9e83-8"
})(_templateObject8());
var ref2;
var FilterDrawerMobileCtaApply = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "FilterDrawerMobileCtaApply",
    componentId: "sc-175c9e83-9"
})(_templateObject9(), (ref2 = storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color) !== null && ref2 !== void 0 ? ref2 : "#222");


/***/ }),

/***/ 77198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N1": function() { return /* reexport */ components_MobileDsAds; },
  "Ei": function() { return /* reexport */ SelectedCategoryItems; }
});

// UNUSED EXPORTS: AllCategoryItems, CatalogProductItem, IntersectionComponent

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody5/utils/index.js
var utils = __webpack_require__(42466);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody5/components/IntersectionComponent.js


function IntersectionComponent_IntersectionComponent(props) {
    var callback = function callback(e) {
        var ref;
        var isIntersecting = e === null || e === void 0 ? void 0 : (ref = e[0]) === null || ref === void 0 ? void 0 : ref.isIntersecting;
        props.onIntersection(isIntersecting);
    };
    var ref = useRef(null);
    var intersectionRef = useCallback(function(node) {
        if (!node) return;
        ref.current = node;
        var observer = new IntersectionObserver(callback, {
            root: null,
            threshold: 0.5
        });
        node && observer.observe(node);
    }, []);
    if (!props.show) return null;
    return /*#__PURE__*/ _jsx("div", {
        ref: intersectionRef,
        className: "flex justify-center mt4 relative",
        children: props.Component ? /*#__PURE__*/ _jsx(props.Component, {
            style: {
                transform: "translateX(-50%)"
            }
        }) : null
    });
}

// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody5/Hybrid.styles.js
var Hybrid_styles = __webpack_require__(40237);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductListWrapper/index.ts
var Widgets2_0_ProductListWrapper = __webpack_require__(68464);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody5/components/CatalogItem.tsx




var CatalogItem = function(props) {
    var item = props.item, catalog_items = props.catalog_items, onItemsImageClick = props.onItemsImageClick, showATCBtn = props.showATCBtn;
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(ListingHeading, {
                id: "listing-".concat(item.id),
                children: item.name || "Available Items"
            }),
            /*#__PURE__*/ _jsx(ProductListWrapper, {
                productList: catalog_items[item.id],
                oldCardConfigs: {
                    showButton: showATCBtn,
                    onItemClick: onItemsImageClick,
                    noTags: true
                }
            })
        ]
    }, "listing-".concat(item.id));
};

// EXTERNAL MODULE: ./src/components/Common/LoaderIcon/index.js
var Common_LoaderIcon = __webpack_require__(65700);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts
var ssrStore = __webpack_require__(20155);
// EXTERNAL MODULE: ./src/utils/scrollOnPageLoad.js
var utils_scrollOnPageLoad = __webpack_require__(87243);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody5/components/AllCategoryItems.js














var isComponentMounted = false;
var isObserverIntersecting = false;
var timeoutIds = (/* unused pure expression or super */ null && ([]));
var AllCategoryItems = function(props) {
    var dispatch = useDispatch();
    var iteratableCategories = props.iteratableCategories, showATCBtn = props.showATCBtn, onItemClick = props.onItemClick, categorySelected = props.categorySelected;
    var store_id = useSSRSelector(function(state) {
        return state.storeReducer.store;
    }).store_id;
    var ref = useState(false), shouldLoad = ref[0], setStartLoad = ref[1];
    var catalog_items = useSelector(function(state) {
        return state.catalogReducer.catalog_items;
    });
    var ref1 = useSelector(function(state) {
        return {
            state: state.catalogReducer.mb5PaginationData.allCategoryComponent,
            singleCategoryState: state.catalogReducer.mb5PaginationData.selectedCategoryComponent
        };
    }), state = ref1.state, singleCategoryState = ref1.singleCategoryState;
    var areAllCategoriesItemsLoaded = useMemo(function() {
        return catalog_items && Object.keys(catalog_items).length === iteratableCategories.length;
    }, [
        catalog_items,
        iteratableCategories
    ]);
    useEffect(function() {
        var scrollConfig = scrollOnPageLoad();
        if (scrollConfig.toScroll) {
            try {
                var y_scroll = scrollConfig.y_scroll;
                setTimeout(function() {
                    sessionStorage.removeItem(CLICKED_ITEM_OBJ);
                    window.scrollTo({
                        top: y_scroll
                    });
                }, 300);
            } catch (err) {
                console.log("timeout time error:", err);
            }
        } else {
            dispatch(resetCatalogsList());
            dispatch(resetMB5AllSelectedCategoryPaginationConfig());
        }
        return function() {
            isComponentMounted = false;
            isObserverIntersecting = false;
        };
    }, []);
    useEffect(function() {
        if (categorySelected === -1 && !areAllCategoriesItemsLoaded) loadProducts();
    }, [
        categorySelected,
        iteratableCategories,
        shouldLoad
    ]);
    var setState = function(argu) {
        return dispatch(setMB5AllCategoryPaginationConfig(argu));
    };
    var loadProducts = function() {
        var _ref = _async_to_generator(function() {
            var ref, currentCategory, ref1, status, isNextPage, currentCategoryIndex, updatedPayload, id;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(iteratableCategories === null || iteratableCategories === void 0 ? void 0 : iteratableCategories[state.currentCategoryIndex]) || !store_id) return [
                            2
                        ];
                        currentCategory = iteratableCategories[state.currentCategoryIndex];
                        state.pageNo = ((ref = singleCategoryState[currentCategory.id]) === null || ref === void 0 ? void 0 : ref.pageNo) || state.pageNo;
                        return [
                            4,
                            getProducts(currentCategory.id, currentCategory.hasOwnProperty("is_custom_tag") ? 1 : 0, state.pageNo, store_id)
                        ];
                    case 1:
                        ref1 = _state.sent(), status = ref1.status, isNextPage = ref1.isNextPage;
                        dispatch(setMB5SelectedCategoryPaginationConfig(_define_property({}, currentCategory.id, {
                            pageNo: state.pageNo + 1,
                            isNext: isNextPage
                        })));
                        /** If status is true then load next, else we maintain the current state which will retry the API call
     * with same configs, when again user focuses on observer component
     */ if (!status) return [
                            2
                        ];
                        currentCategoryIndex = !isNextPage ? state.currentCategoryIndex + 1 : state.currentCategoryIndex;
                        updatedPayload = {
                            currentCategoryIndex: currentCategoryIndex,
                            isNextPage: isNextPage,
                            pageNo: !isNextPage ? 1 : state.pageNo + 1,
                            showLoaderComponent: !!(iteratableCategories === null || iteratableCategories === void 0 ? void 0 : iteratableCategories[state.currentCategoryIndex])
                        };
                        setState(updatedPayload);
                        if (!isComponentMounted) isComponentMounted = true;
                        // Trigger next product loads when the observer is still in view
                        if (isObserverIntersecting) {
                            id = setTimeout(triggerProductLoad, 600);
                            timeoutIds.push(id);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function loadProducts() {
            return _ref.apply(this, arguments);
        };
    }();
    var triggerProductLoad = function() {
        return setStartLoad(function(load) {
            return !load;
        });
    };
    var onIntersection = function(isIntersecting) {
        isObserverIntersecting = isIntersecting;
        if (isIntersecting && isComponentMounted) triggerProductLoad();
    };
    var _RenderCategoriesWithItems = function() {
        if (!(iteratableCategories === null || iteratableCategories === void 0 ? void 0 : iteratableCategories.length)) return null;
        return iteratableCategories.map(function(item) {
            var ref;
            return item.hasOwnProperty("is_active") && item.is_active === 0 || !!(catalog_items === null || catalog_items === void 0 ? void 0 : (ref = catalog_items[item.id]) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ _jsx(CatalogProductItem, {
                item: item,
                catalog_items: catalog_items,
                onItemsImageClick: onItemClick,
                showATCBtn: showATCBtn
            }, item.id.toString());
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            _RenderCategoriesWithItems(),
            /*#__PURE__*/ _jsx(IntersectionComponent, {
                show: state.showLoaderComponent,
                onIntersection: onIntersection,
                Component: LoaderIcon
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/aos/dist/aos.js
var aos = __webpack_require__(2711);
var aos_default = /*#__PURE__*/__webpack_require__.n(aos);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(86812);
// EXTERNAL MODULE: ./src/utils/removeDsAdsRouteLink.js
var removeDsAdsRouteLink = __webpack_require__(95218);
;// CONCATENATED MODULE: ./src/components/DesignSystem/DigitalShowroomAds/MiddleBodyMobileReasonModal.js



function MiddleBodyMobileReasonModal(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex f12px pa14px fw6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "top-section pb14px",
                        children: "You are seeing this Ad because owner of this website is using the free version"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row justify-between items-center pl18px pr18px black-90",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex f12px fw6",
                        children: [
                            "If you own this website ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "then you can remove this."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "f12px",
                        onClick: removeDsAdsRouteLink/* removeDsAdsRouteLink */.k,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "remove-adsection pa12px fw7",
                            children: "Remove this Ad"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var DigitalShowroomAds_MiddleBodyMobileReasonModal = (MiddleBodyMobileReasonModal);

// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody6/Hybrid.styles.js
var MiddleBody6_Hybrid_styles = __webpack_require__(43955);
// EXTERNAL MODULE: ./src/assets/svgExports/InfoIcon.js
var InfoIcon = __webpack_require__(67313);
// EXTERNAL MODULE: ./src/components/DesignSystem/DigitalShowroomAds/ReasonModalHOC.js + 2 modules
var ReasonModalHOC = __webpack_require__(93992);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/checkIfThemePreview.js
var checkIfThemePreview = __webpack_require__(15483);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody5/components/MobileDsAds.js
















var mobileColumnNumber = 2; // Number of columns in mobile view for grid
var adRepeatGridLinesConstant = 3; // approx repeating ad after how many grid lines are spanned
var EvalIndexMultiplier = mobileColumnNumber * adRepeatGridLinesConstant; // helper constant for calculation
var incomingNewDataPoints = 0; // helper variable for new productIds that will come
function MobileDsAds(props) {
    var toggleMobileAdReasonModal = /**
   * product.id -> reasonModal Toggled
   * @param {*} id - product id to be toggled
   * @param {*} isReasonModalOpen  - Toggle status of ReasonModal
   */ function toggleMobileAdReasonModal(id, isReasonModalOpen) {
        var tempShowAd = (0,_object_spread/* default */.Z)({}, showAdInfo);
        tempShowAd[id] = isReasonModalOpen;
        setShowAdInfo(tempShowAd);
    };
    var initiateShowAdObject = /**
   * maps product-id's to show if reasonModal
   * corresponding to Ad to false initially
   */ function initiateShowAdObject() {
        var tempShowAdObject = {};
        for(var i = 0; i < dataIdForAds.length; i++){
            tempShowAdObject[dataIdForAds[i]] = false;
        }
        setShowAdInfo(tempShowAdObject);
    };
    var setDataIdArray = /**
   * Appends New ProductId in DataIdArray
   * that will come after processing all items inside Category
   * @param {*} item
   * @param {*} remainder
   */ function setDataIdArray(item, remainder) {
        if (incomingNewDataPoints === 0) {
            var evaluatedIndex = 0;
            setDataIdForAds(function(dataIdForAds) {
                var ref;
                return (0,_to_consumable_array/* default */.Z)(dataIdForAds).concat([
                    (ref = catalog_items[item][evaluatedIndex]) === null || ref === void 0 ? void 0 : ref.id, 
                ]);
            });
        } else {
            var _loop = function() {
                var evaluatedIndex = incomingNewDataPoints * EvalIndexMultiplier - 1;
                setDataIdForAds(function(dataIdForAds) {
                    var ref;
                    return (0,_to_consumable_array/* default */.Z)(dataIdForAds).concat([
                        (ref = catalog_items[item][evaluatedIndex - remainder]) === null || ref === void 0 ? void 0 : ref.id, 
                    ]);
                });
                incomingNewDataPoints--;
            };
            while(incomingNewDataPoints)_loop();
        }
    };
    var getMobileDataIdForAds = /**
   * the function Aprroximates place ad after every 3 CSS Grid Row Span
   * sets {array} -> product.id Below which the ads are placed.
   */ function getMobileDataIdForAds() {
        var totalGridRowLines = 0;
        Object.keys(catalog_items).map(function(item) {
            totalGridRowLines += Math.ceil(catalog_items[item].length / mobileColumnNumber);
            if (Math.floor(totalGridRowLines / adRepeatGridLinesConstant) !== 0) {
                var totalLinesInCategory = Math.ceil(catalog_items[item].length / mobileColumnNumber);
                var remainder = catalog_items[item].length % mobileColumnNumber;
                incomingNewDataPoints = Math.floor(totalLinesInCategory / adRepeatGridLinesConstant);
                setDataIdArray(item, remainder);
                totalGridRowLines = 0;
            }
        });
    };
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)({}), showAdInfo = ref3[0], setShowAdInfo = ref3[1];
    var ref4 = (0,react.useState)([]), dataIdForAds = ref4[0], setDataIdForAds = ref4[1];
    var catalog_items = (0,es/* useSelector */.v9)(function(state) {
        return {
            catalog_items: state.catalogReducer.catalog_items
        };
    }).catalog_items;
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    });
    var isPreview = (0,checkIfThemePreview/* default */.Z)();
    (0,react.useEffect)(function() {
        aos_default().init();
    }, []);
    (0,react.useEffect)(function() {
        initiateShowAdObject();
    }, [
        dataIdForAds
    ]);
    (0,react.useEffect)(function() {
        setDataIdForAds([]);
        getMobileDataIdForAds();
    }, [
        catalog_items
    ]);
    return !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf && dataIdForAds.includes(props.data.id) && ((ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.non_premium_ad_url_mobile) && !((ref1 = storeData.theme) === null || ref1 === void 0 ? void 0 : ref1.is_demo) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBody6_Hybrid_styles/* AdContainer */.g1, {
            "data-aos": "fade-right",
            "data-aos-duration": "1000",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-column digital-showroom__ads pb20px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex container-width pb10px",
                        onClick: function() {
                            return toggleMobileAdReasonModal(props.data.id, true);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex f12px o-50 mb6px",
                                children: "Why I am seeing this?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ml4px f10px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon/* InfoIcon */.s, {
                                    size: 16,
                                    secondaryColor: "#838383"
                                })
                            })
                        ]
                    }),
                    showAdInfo[props.data.id] && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReasonModalHOC/* default */.Z, {
                        reasonModal: DigitalShowroomAds_MiddleBodyMobileReasonModal,
                        toggleAdReasonModal: function() {
                            return toggleMobileAdReasonModal(props.data.id, false);
                        },
                        className: "middle-body-mobile-reason-modal",
                        ml: -1.15,
                        translateX: 9.5,
                        translateY: -1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex gif-height items-start pointer",
                        onClick: removeDsAdsRouteLink/* removeDsAdsRouteLink */.k,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: (ref2 = storeData.store_info) === null || ref2 === void 0 ? void 0 : ref2.non_premium_ad_url_mobile,
                            width: 630,
                            height: 187
                        })
                    })
                ]
            })
        }) : null
    });
}
/* harmony default export */ var components_MobileDsAds = (MobileDsAds);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/DukaanCard/index.js
var DukaanCard = __webpack_require__(28364);
// EXTERNAL MODULE: ./src/components/FlatList/index.js
var FlatList = __webpack_require__(55772);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts + 6 modules
var WidgetDndContext = __webpack_require__(17502);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/GlobalCfeLoader.tsx
var GlobalCfeLoader = __webpack_require__(79220);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/PromoSlider/index.tsx + 1 modules
var PromoSlider = __webpack_require__(98521);
// EXTERNAL MODULE: ./src/constants/promos.js
var promos = __webpack_require__(10445);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody5/components/SelectedCategoryItems.tsx











// import LoaderIcon from '@/components/Common/LoaderIcon';








var SelectedCategoryItems = function(props) {
    var ref, ref1, ref2;
    var ref3 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), globalStyle = ref3.widgetContextState.globalStyle;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref4 = (0,react.useState)(false), isProductsLoading = ref4[0], setIsProductsLoading = ref4[1];
    var ref5 = (0,react.useState)(false), canLoadProducts = ref5[0], setCanLoadProducts = ref5[1];
    var ref6 = (0,react.useState)([]), promosData = ref6[0], setPromosData = ref6[1];
    var iteratableCategories = props.iteratableCategories, showATCBtn = props.showATCBtn, onItemClick = props.onItemClick, categorySelected = props.categorySelected, activeCategoryIndex = props.activeCategoryIndex;
    var ref7 = (0,es/* useSelector */.v9)(function(state) {
        var catalogData = state.catalogReducer;
        return {
            catalogData: catalogData,
            commonData: state.commonReducer,
            state: catalogData.mb5PaginationData.selectedCategoryComponent
        };
    }), _catalogData = ref7.catalogData, catalog_items = _catalogData.catalog_items, productTags = _catalogData.productTags, loader = ref7.commonData.loader, state = ref7.state;
    var catID = (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid) || categorySelected;
    var isTag = productTags.findIndex(function(tag) {
        return tag.id === +catID;
    }) >= 0;
    var selectedPaginationConfig = state[catID];
    var isNextPage = selectedPaginationConfig === null || selectedPaginationConfig === void 0 ? void 0 : selectedPaginationConfig.isNext;
    (0,react.useEffect)(function() {
        var scrollConfig = (0,utils_scrollOnPageLoad/* scrollOnPageLoad */.l)();
        if (scrollConfig.toScroll) {
            try {
                var y_scroll = scrollConfig.y_scroll;
                setTimeout(function() {
                    sessionStorage.removeItem(constants/* CLICKED_ITEM_OBJ */.uI);
                    window.scrollTo({
                        top: y_scroll
                    });
                }, 300);
            } catch (err) {
                console.log("timeout time error:", err);
            }
        } else {
            dispatch((0,catalog/* resetCatalogsList */.wL)(catID));
            setState((0,src_define_property/* default */.Z)({}, catID, {
                pageNo: 1,
                isNext: true
            }));
        }
        if (catID >= 0) {
            if (!selectedPaginationConfig) setState((0,src_define_property/* default */.Z)({}, catID, {
                pageNo: 1,
                isNext: true
            }));
        }
        setCanLoadProducts(true);
    }, [
        catID,
        iteratableCategories
    ]);
    var setState = function(argu) {
        return dispatch((0,catalog/* setMB5SelectedCategoryPaginationConfig */.IF)(argu));
    };
    var loadProducts = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(pageNo) {
            var ref, isListFetched, isNextPage;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,utils/* getProducts */.X)(catID, isTag ? 1 : 0, pageNo)
                        ];
                    case 1:
                        ref = _state.sent(), isListFetched = ref.status, isNextPage = ref.isNextPage;
                        return [
                            2,
                            {
                                isListFetched: isListFetched,
                                isNextPage: isNextPage
                            }
                        ];
                }
            });
        });
        return function loadProducts(pageNo) {
            return _ref.apply(this, arguments);
        };
    }();
    var setPageNumber = function(pageNo, isNext) {
        return setState((0,src_define_property/* default */.Z)({}, catID, {
            pageNo: pageNo,
            isNext: isNext
        }));
    };
    var getItemName = function(item) {
        return item === null || item === void 0 ? void 0 : item.name;
    };
    var loadMoreData = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var nextPageNum, ref, isNext, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        if (!isNextPage || loader) return [
                            2
                        ];
                        setIsProductsLoading(true);
                        nextPageNum = state[catID].pageNo || 1;
                        return [
                            4,
                            loadProducts(nextPageNum)
                        ];
                    case 1:
                        ref = _state.sent(), isNext = ref.isNextPage;
                        nextPageNum += 1;
                        setPageNumber(nextPageNum, isNext);
                        return [
                            3,
                            4
                        ];
                    case 2:
                        err = _state.sent();
                        console.log("Error:  ", err);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setIsProductsLoading(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function loadMoreData() {
            return _ref.apply(this, arguments);
        };
    }();
    if (!(iteratableCategories === null || iteratableCategories === void 0 ? void 0 : iteratableCategories.length)) {
        return null;
    }
    return canLoadProducts && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hybrid_styles/* ListingHeading */.E, {
                id: "listing-".concat(categorySelected),
                children: getItemName(iteratableCategories[activeCategoryIndex]) || "Available Items"
            }),
            !!(promosData === null || promosData === void 0 ? void 0 : promosData.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hybrid_styles/* PromoSliderContainer */.GW, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoSlider/* default */.Z, {
                    setPromosDataToParent: setPromosData,
                    type: isTag ? promos/* PROMO_APPLICABILITY_TYPES.TAG */.d.TAG : promos/* PROMO_APPLICABILITY_TYPES.CATEGORY */.d.CATEGORY,
                    typeId: catID
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatList/* default */.Z, {
                        isLoaderVisible: isProductsLoading,
                        isNext: isNextPage,
                        onScrollEnd: loadMoreData,
                        renderInsideFragment: true,
                        renderList: function() {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Widgets2_0_ProductListWrapper/* ProductListWrapper */.X, {
                                productList: catalog_items[categorySelected],
                                oldCardConfigs: {
                                    showButton: showATCBtn,
                                    onItemClick: onItemClick,
                                    noTags: productTags.findIndex(function(tag) {
                                        return tag.id === +categorySelected;
                                    }) !== -1
                                },
                                hideLoaderSkeleton: true
                            });
                        }
                    }),
                    loader && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DukaanCard/* default */.Z, {
                                isLoader: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DukaanCard/* default */.Z, {
                                isLoader: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DukaanCard/* default */.Z, {
                                isLoader: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DukaanCard/* default */.Z, {
                                isLoader: true
                            })
                        ]
                    })
                ]
            }),
            isNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center mt4 relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalCfeLoader/* GlobalCfeLoader */.I, {
                    type: (globalStyle === null || globalStyle === void 0 ? void 0 : (ref1 = globalStyle.appLoader) === null || ref1 === void 0 ? void 0 : ref1.loaderId) || "ellipsis",
                    color: globalStyle === null || globalStyle === void 0 ? void 0 : (ref2 = globalStyle.appLoader) === null || ref2 === void 0 ? void 0 : ref2.color
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody5/components/index.js







/***/ }),

/***/ 42466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ getProducts; }
/* harmony export */ });
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96031);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45726);


var getProducts = function(id, type) {
    var pageNo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, storeId = arguments.length > 3 ? arguments[3] : void 0;
    var staleStoreId = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store.store_id;
    var dispatch = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].dispatch */ .Z.dispatch;
    var sID = storeId || staleStoreId;
    if (!sID) return;
    return new Promise(function(resolve, reject) {
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_1__/* .fetchCatalogItemsByCategoryId */ .Is)({
            store_id: sID,
            category_id: id,
            category_type: type,
            page_no: pageNo
        }, function(status, isNextPage) {
            return status ? resolve({
                status: status,
                isNextPage: isNextPage
            }) : reject(status);
        }));
    });
};


/***/ }),

/***/ 43955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ ListingHeading; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "X6": function() { return /* binding */ Heading; },
/* harmony export */   "Z5": function() { return /* binding */ AllCategorySection; },
/* harmony export */   "bu": function() { return /* binding */ AllCategoryButton; },
/* harmony export */   "g1": function() { return /* binding */ AdContainer; },
/* harmony export */   "rV": function() { return /* binding */ MiddleBodyAdWrapper; }
/* harmony export */ });
/* unused harmony export Listing */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50066);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        ";\n  width: ",
        ";\n  display: flex;\n  max-width: 1600px;\n  flex-direction: column;\n  height: auto;\n  box-sizing: border-box;\n  position: relative;\n  margin: 0 auto;\n  ",
        "\n  @media screen and (max-width: 767px) {\n    padding-top: 0;\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  width: 100%;\n  font-size: 40px;\n  color: ",
        ";\n\n  @media screen and (min-width: 767px) {\n    font-size: 40px;\n    margin-bottom: 3rem;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 28px;\n    margin-bottom: 2rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 1000px;\n  display: grid;\n  grid-template-rows: auto;\n  justify-items: center;\n  box-sizing: border-box;\n  margin-bottom: 3rem;\n\n  @media screen and (min-width: 767px) {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    row-gap: 2rem;\n    column-gap: 1.5rem;\n    padding: 0 2rem;\n  }\n\n  @media screen and (max-width: 766px) {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    row-gap: 1.5rem;\n    column-gap: 1rem;\n    padding: 0 1rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #000000;\n  font-weight: 600;\n  margin-bottom: 0.8rem;\n\n  @media screen and (min-width: 767px) {\n    font-size: 28px;\n    padding: 0 0;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 20px;\n    padding: 0 20px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  position: sticky;\n  bottom: 5%;\n  z-index: 5;\n  background: transparent;\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  border-radius: 30px;\n  box-shadow: 0px 16px 36px #0000004a;\n  background: ",
        " 0% 0% no-repeat padding-box;\n  color: ",
        ";\n  cursor: pointer;\n\n  @media screen and (min-width: 767px) {\n    font-size: 18px;\n    padding: 16px 40px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n    padding: 14px 16px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  grid-column-start: 1;\n  grid-column-end: 3;\n  background: ",
        ";\n  padding-top: ",
        "px;\n  padding-bottom: ",
        "px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  background: #fff;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

function slideInAnimate() {
    return "\n    animation-name: slide-in;\n    animation-duration: 0.5s;\n    transform : translateX(50px);\n\n    @keyframes slide-in {\n      from {\n          transform : translateX(0px);\n      }\n      to {\n          transform : translateX(50px);\n      }\n    }\n    ";
}
function slideOutAnimate(trasnlationDist) {
    return "\n    animation-name: slide-out;\n    animation-duration: 0.50s;\n\n    @keyframes slide-out {\n      from {\n          transform : translateX(50px);\n      }\n      to {\n        transform : translateX(-".concat(trasnlationDist - 50, "px);\n      }\n    }\n    ");
}
var Container = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].article.withConfig */ .ZP.article.withConfig({
    displayName: "Container",
    componentId: "sc-81fe99c9-0"
})(_templateObject(), function(props) {
    return props.isBuilderMobile ? "4rem 16px 2rem" : "4rem 0 2rem";
}, function(props) {
    return props.isBuilderMobile ? "100%" : "80%";
}, function(props) {
    return props.showFilterDrawer === null ? "" : props.showFilterDrawer ? slideInAnimate() : slideOutAnimate(props.trasnlationDist);
});
var Heading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    displayName: "Heading",
    componentId: "sc-81fe99c9-1"
})(_templateObject1(), function(props) {
    return props.fontColor || "#000000";
});
var Listing = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "Listing",
    componentId: "sc-81fe99c9-2"
})(_templateObject2());
var ListingHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    displayName: "ListingHeading",
    componentId: "sc-81fe99c9-3"
})(_templateObject3());
var AllCategorySection = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AllCategorySection",
    componentId: "sc-81fe99c9-4"
})(_templateObject4());
var AllCategoryButton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AllCategoryButton",
    componentId: "sc-81fe99c9-5"
})(_templateObject5(), function(props) {
    return props.backgroundColor || "#ffffff";
}, function(props) {
    return props.backgroundColor ? "#ffffff" : "#000000";
});
var AdContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AdContainer",
    componentId: "sc-81fe99c9-6"
})(_templateObject6(), function(props) {
    return props.backgroundColor || "#FFFFFF";
}, function(props) {
    return props.paddingTop || 0;
}, function(props) {
    return props.paddingBottom || 0;
});
var MiddleBodyAdWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "MiddleBodyAdWrapper",
    componentId: "sc-81fe99c9-7"
})(_templateObject7());


/***/ }),

/***/ 39996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ ProductListWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/hooks/useGetDeviceType.tsx
var useGetDeviceType = __webpack_require__(62946);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
// EXTERNAL MODULE: ./src/hooks/useItemClick.js + 1 modules
var useItemClick = __webpack_require__(80058);
// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody5/components/index.js + 6 modules
var components = __webpack_require__(77198);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts + 6 modules
var WidgetDndContext = __webpack_require__(17502);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductCard/utils.tsx + 1 modules
var utils = __webpack_require__(81241);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/Snackbar/Snackbar.tsx
var Snackbar = __webpack_require__(85810);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductListWrapper/utils.ts
var ProductListWrapper_utils = __webpack_require__(2386);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react-virtuoso/dist/index.mjs
var dist = __webpack_require__(26246);
// EXTERNAL MODULE: ./src/components/DesignSystem/Card/index.js + 1 modules
var Card = __webpack_require__(93574);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
;// CONCATENATED MODULE: ./src/components/VirtualisedList/index.tsx










var INCREASE_VIEWPORT_BY = 0;
/**
 * the main idea behind this component is to treat the rows as ->
 * 1. `components` - which will have full width and can be changed to any component like heading.
 * 2. `sliced-flex-cards` - which is a flex row containing product cards.
 */ // eslint-disable-next-line react/display-name
var VirtualisedGridList = /*#__PURE__*/ (0,react.memo)(/*#__PURE__*/ (0,react.forwardRef)(function(param, virtualisedGridListReference) {
    var listData = param.listData, renderProductCard = param.renderProductCard, itemsRenderConfig = param.itemsRenderConfig, virtualisationContainerStyle = param.virtualisationContainerStyle, _useWindowScroll = param.useWindowScroll, useWindowScroll = _useWindowScroll === void 0 ? true : _useWindowScroll, defaultItemHeight = param.defaultItemHeight;
    var generateCardRows = /**
       * takes a list of card items and convert then into groups of cards to render in each row.
       * number of items in each row is defined by `itemsRenderConfig.columnCount`,
       */ function generateCardRows(indexedListData, index) {
        var ref;
        var resultantPageData = [];
        var rowData = [];
        while(isItemCardType((ref = indexedListData[index]) === null || ref === void 0 ? void 0 : ref.type)){
            var rowId = "".concat(index);
            for(var rowItems = 0; rowItems < itemsRenderConfig.columnCount; rowItems++){
                if (!indexedListData[index]) {
                    break;
                }
                if (isItemCardType(indexedListData[index].type)) {
                    rowData.push(indexedListData[index]);
                    rowId = "".concat(rowId, "-").concat(indexedListData[index].id);
                    index += 1;
                } else {
                    break;
                }
            }
            resultantPageData.push({
                type: "sliced-flex-cards",
                data: rowData,
                id: rowId
            });
            rowData = [];
        }
        return {
            cardRows: resultantPageData,
            updatedIndex: index
        };
    };
    var virtuosoGridRef = (0,react.useRef)(null);
    /**
       * to track previous value of range.
       * keys can have any value (just to maintain an entry).
       * this will help in reducing calls for `intersectionCallback`
       * check implementation of `handleRangeChanged`
       */ var rowChangeTrackerRef = (0,react.useRef)({});
    var isItemCardType = function(itemType) {
        return itemType === "product-card" || itemType === "product-card-skeleton";
    };
    /**
       * NOTE:- any operation on this page will now be done on slicedItems (unless there is a very specific need)
       * converting a list of items whose types are defined in `ItemTypes` to renderable format.
       *
       * ## representing items by type
       * eg. ["component", "product-card", "product-card","product-card","product-card","product-card","product-card"]
       * lets say `itemsRenderConfig.columnCount` = 3
       * [
       *    "component",
       *    "sliced-flex-cards": ["product-card", "product-card","product-card"],
       *    "sliced-flex-cards": ["product-card", "product-card","product-card"],
       * ]
       *
       * this function treats `product-card` and `product-card-skeleton` as similar objects.
       * to add/remove skeleton loaders, we need to add/remove them from listData
       */ var slicedItems = (0,react.useMemo)(function() {
        var resultantPageData = [];
        var indexedListData = listData === null || listData === void 0 ? void 0 : listData.map(function(item, idx) {
            // indexedListData will have an index key for every item so that the items can be tracked after shuffling in slicing phase
            item.index = idx;
            return item;
        });
        for(var index = 0; index < (indexedListData === null || indexedListData === void 0 ? void 0 : indexedListData.length); index++){
            // whenever a card is found, make sets of cards for rendering in a row
            if (isItemCardType(indexedListData[index].type)) {
                var cardRowsObj = generateCardRows(indexedListData, index);
                index = cardRowsObj.updatedIndex;
                resultantPageData = (0,_to_consumable_array/* default */.Z)(resultantPageData || []).concat((0,_to_consumable_array/* default */.Z)(cardRowsObj.cardRows || []));
            }
            resultantPageData.push(indexedListData[index]);
        }
        return resultantPageData;
    }, [
        listData
    ]);
    // extracting the `scrollToIndex` from Virtuoso component and exposing it to parent for the auto scroll functionality
    (0,react.useImperativeHandle)(virtualisedGridListReference, function() {
        return {
            scrollToIndex: handleScrollToIndex
        };
    });
    /**
       * since every row is either a `sliced-flex-cards` or a `component`,
       * we calculate the index where an element to scroll is lying after converting to sliced flex.
       */ var handleScrollToIndex = function(indexToScroll) {
        var _loop = function(index) {
            var item = slicedItems[index];
            if ((item === null || item === void 0 ? void 0 : item.type) === "sliced-flex-cards") {
                var ref;
                (ref = item === null || item === void 0 ? void 0 : item.data) === null || ref === void 0 ? void 0 : ref.forEach(function(sliceItem) {
                    if (sliceItem.index === indexToScroll) {
                        idexToScrollAfterSlicing = index;
                    }
                });
            } else {
                if (indexToScroll === (item === null || item === void 0 ? void 0 : item.index)) {
                    idexToScrollAfterSlicing = index;
                }
            }
        };
        var idexToScrollAfterSlicing = undefined;
        for(var index = 0; index <= (slicedItems === null || slicedItems === void 0 ? void 0 : slicedItems.length); index++)_loop(index);
        if (idexToScrollAfterSlicing || idexToScrollAfterSlicing === 0) {
            var // offset to place scrolled item in center
            ref, ref1;
            virtuosoGridRef === null || virtuosoGridRef === void 0 ? void 0 : (ref = virtuosoGridRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.scrollToIndex) === null || ref1 === void 0 ? void 0 : ref1.call(ref, {
                index: idexToScrollAfterSlicing,
                align: "center",
                offset: 200
            });
        }
    };
    var handleRangeChanged = function(range) {
        var previousRange = cloneDeep_default()(rowChangeTrackerRef.current);
        var newRange = {};
        var startIndex = range === null || range === void 0 ? void 0 : range.startIndex;
        var endIndex = range === null || range === void 0 ? void 0 : range.endIndex;
        for(var index = startIndex; index <= endIndex; index++){
            // track all indexes currently on screen
            newRange[index] = 1;
            // exclude intersection callback if index present in previous row change
            if (previousRange[index]) {
                continue;
            }
            var item = slicedItems === null || slicedItems === void 0 ? void 0 : slicedItems[index];
            if (!item) {
                break;
            }
            if (item.type === "sliced-flex-cards") {
                var ref;
                (ref = item === null || item === void 0 ? void 0 : item.data) === null || ref === void 0 ? void 0 : ref.forEach(function(element) {
                    var ref;
                    element === null || element === void 0 ? void 0 : (ref = element.intersectionCallback) === null || ref === void 0 ? void 0 : ref.call(element);
                });
            } else {
                var ref1;
                item === null || item === void 0 ? void 0 : (ref1 = item.intersectionCallback) === null || ref1 === void 0 ? void 0 : ref1.call(item);
            }
        }
        rowChangeTrackerRef.current = newRange;
    };
    var renderItemContent = (0,react.useCallback)(function(index, listItem) {
        if ((listItem === null || listItem === void 0 ? void 0 : listItem.type) === "component") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(listItem.Component, {});
        } else if ((listItem === null || listItem === void 0 ? void 0 : listItem.type) === "sliced-flex-cards") {
            var ref;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    columnGap: itemsRenderConfig.columnGap,
                    margin: "".concat(itemsRenderConfig.rowGap, "px 0")
                },
                className: "tw-flex tw-flex-row tw-items-start tw-justify-start",
                children: listItem === null || listItem === void 0 ? void 0 : (ref = listItem.data) === null || ref === void 0 ? void 0 : ref.map(function(item, idx) {
                    if ((item === null || item === void 0 ? void 0 : item.type) === "product-card") {
                        return renderProductCard(item === null || item === void 0 ? void 0 : item.index, item === null || item === void 0 ? void 0 : item.data);
                    } else if ((item === null || item === void 0 ? void 0 : item.type) === "product-card-skeleton") {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Card, {
                            skeleton: true,
                            skeletonImage: constants/* CARD_SKELETON */.wv
                        }, idx);
                    }
                })
            });
        }
    }, [
        slicedItems
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Virtuoso */.OO, {
        useWindowScroll: useWindowScroll,
        ref: virtuosoGridRef,
        rangeChanged: handleRangeChanged,
        increaseViewportBy: INCREASE_VIEWPORT_BY,
        data: slicedItems,
        defaultItemHeight: defaultItemHeight || 400,
        itemContent: renderItemContent,
        components: {
            Item: function(_param) {
                var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
                    "children"
                ]);
                var itemIndex = props === null || props === void 0 ? void 0 : props["data-index"];
                var correspondingItem = slicedItems === null || slicedItems === void 0 ? void 0 : slicedItems[itemIndex];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    // Just to remove an error due zero element height in the internal working of virtuoso
                    style: {
                        minHeight: "1px"
                    },
                    children: children
                }), correspondingItem === null || correspondingItem === void 0 ? void 0 : correspondingItem.id);
            },
            // eslint-disable-next-line react/display-name
            List: /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
                var style = _param.style, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
                    "style",
                    "children"
                ]);
                return (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    ref: ref
                }, props), {
                    style: (0,_object_spread/* default */.Z)({}, style, virtualisationContainerStyle),
                    children: children
                }));
            })
        }
    });
}), function(prevProps, nextProps) {
    var ref, ref1;
    return (prevProps === null || prevProps === void 0 ? void 0 : (ref = prevProps.listData) === null || ref === void 0 ? void 0 : ref.length) === (nextProps === null || nextProps === void 0 ? void 0 : (ref1 = nextProps.listData) === null || ref1 === void 0 ? void 0 : ref1.length);
});
VirtualisedGridList.displayName = "VirtualisedGridList";
/* harmony default export */ var VirtualisedList = (VirtualisedGridList);

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ProductListWrapper/ProductListWrapper.tsx
















var ProductListWrapper_Card = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 93574)).then(function(mod) {
        return mod.Card;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93574)
            ];
        }
    }
});
var ProductCard = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4985), __webpack_require__.e(437), __webpack_require__.e(9129), __webpack_require__.e(2755), __webpack_require__.e(8502)]).then(__webpack_require__.bind(__webpack_require__, 32755)).then(function(mod) {
        return mod.ProductCard;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32755)
            ];
        }
    }
});
var AdvanceCard = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5195).then(__webpack_require__.bind(__webpack_require__, 85195)).then(function(mod) {
        return mod.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85195)
            ];
        }
    }
});
// Product list is put got like this to get category wise data etc.
// eslint-disable-next-line react/display-name
var ProductListWrapper = /*#__PURE__*/ (0,react.forwardRef)(function(param, productListWrapperReference) {
    var _children = param.children, children = _children === void 0 ? null : _children, _productList = param.productList, productList = _productList === void 0 ? [] : _productList, _oldCardConfigs = param.oldCardConfigs, oldCardConfigs = _oldCardConfigs === void 0 ? {
        showButton: true,
        noTags: false,
        showCategoryCard: false,
        noTagsReadState: "fromProp"
    } : _oldCardConfigs, _hideLoaderSkeleton = param.hideLoaderSkeleton, hideLoaderSkeleton = _hideLoaderSkeleton === void 0 ? false : _hideLoaderSkeleton, _skeletonCount = param.skeletonCount, skeletonCount = _skeletonCount === void 0 ? 3 : _skeletonCount, _overrideGlobalBuilderProductCard = param.overrideGlobalBuilderProductCard, overrideGlobalBuilderProductCard = _overrideGlobalBuilderProductCard === void 0 ? false : _overrideGlobalBuilderProductCard, _renderAdvancedCard = param.renderAdvancedCard, renderAdvancedCard = _renderAdvancedCard === void 0 ? false : _renderAdvancedCard, _CustomCardComponent = param.CustomCardComponent, CustomCardComponent = _CustomCardComponent === void 0 ? null : _CustomCardComponent, customClass = param.customClass, _calculateSelfDimensions = param.calculateSelfDimensions, calculateSelfDimensions = _calculateSelfDimensions === void 0 ? false : _calculateSelfDimensions, _renderType = param.renderType, renderType = _renderType === void 0 ? "grid" : _renderType;
    var ref = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref.widgetContextState, isBuilder = _widgetContextState.isBuilder, previewDevice = _widgetContextState.previewDevice;
    var ref1 = (0,ProductListWrapper_utils/* useProductCardElements */.S)(), layoutElement = ref1.layoutElement, infoList = ref1.infoList, isProductCardEnabled = ref1.isProductCardEnabled;
    var showCustomProductCard = isProductCardEnabled && (infoList === null || infoList === void 0 ? void 0 : infoList.length) && !overrideGlobalBuilderProductCard ? true : false;
    var layoutElementConfig = layoutElement === null || layoutElement === void 0 ? void 0 : layoutElement.config;
    var cardWrapperConfigs = (0,utils/* getCartWrapperConfigs */.Ui)(layoutElementConfig);
    var productItemContainerRef = (0,react.useRef)(null);
    var virtuosoGridRef = (0,react.useRef)(null);
    var deviceType = (0,useGetDeviceType/* useGetDeviceType */.n)().deviceType;
    var isMobile = (isBuilder ? previewDevice === "mobile" : false) || deviceType === "mobile";
    var ref2 = (0,react.useState)({
        containerWidth: 0
    }), listDimensions = ref2[0], setListDimensions = ref2[1];
    var columnsMobile = (layoutElementConfig === null || layoutElementConfig === void 0 ? void 0 : layoutElementConfig.numColumnsMobile) || 2;
    var coumnsDesktop = (layoutElementConfig === null || layoutElementConfig === void 0 ? void 0 : layoutElementConfig.numColumnsDesktop) || 3;
    var gaps = function() {
        var gap = {
            columnGap: 20,
            rowGap: 30
        };
        if (!showCustomProductCard) return gap;
        if (!isMobile && !cardWrapperConfigs.isCardLayout) {
            gap.columnGap = 28;
            gap.rowGap = 52;
            return gap;
        }
        if (!isMobile && cardWrapperConfigs.isCardLayout) {
            gap.columnGap = 16;
            gap.rowGap = 16;
            return gap;
        }
        if (isMobile && !cardWrapperConfigs.isCardLayout) {
            gap.columnGap = 16;
            gap.rowGap = 32;
            return gap;
        }
        gap.columnGap = 8;
        gap.rowGap = 8;
        return gap;
    }();
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useItemClick/* useItemClick */.M)(), 1), onItemClick = ref3[0];
    var columnNum = isMobile ? columnsMobile : coumnsDesktop;
    var OldCardComponent = CustomCardComponent || (!renderAdvancedCard ? ProductListWrapper_Card : AdvanceCard);
    var ref4 = (0,react.useState)({
        open: false,
        message: ""
    }), snackbarConfig = ref4[0], setSnackbarConfig = ref4[1];
    // extracting the `scrollToIndex` from Virtuoso component and exposing it to parent for the auto scroll functionality
    (0,react.useImperativeHandle)(productListWrapperReference, function() {
        return {
            scrollToIndex: function(index) {
                var ref, ref1;
                return virtuosoGridRef === null || virtuosoGridRef === void 0 ? void 0 : (ref = virtuosoGridRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.scrollToIndex) === null || ref1 === void 0 ? void 0 : ref1.call(ref, index);
            }
        };
    });
    (0,react.useEffect)(function() {
        var updateDimensions = function updateDimensions() {
            var ref;
            var sectionWidth = (ref = productItemContainerRef.current) === null || ref === void 0 ? void 0 : ref.clientWidth;
            if (sectionWidth) {
                setListDimensions(function(items) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, items), {
                        containerWidth: sectionWidth
                    });
                });
            }
        };
        var resObserver = new ResizeObserver(updateDimensions);
        productItemContainerRef.current && resObserver.observe(productItemContainerRef.current);
        updateDimensions();
        return function() {
            productItemContainerRef.current && resObserver.unobserve(productItemContainerRef.current);
        };
    }, []);
    // This is the padding that is added in the card when images is rendered in the card with padding
    // Horizontal Padding is added i.e. 10(leftPad) & 10(rightPad) = 20, will be removed from calculated
    // Image width will be minus these
    var cardWithMarginDimensions = cardWrapperConfigs.isCardLayout && !cardWrapperConfigs.isFullWidth ? isMobile ? 20 : 28 : 0;
    var imageWidth = function() {
        var totalGapWidth = (columnNum - (!isMobile ? 1 : 0)) * gaps.columnGap;
        var oneCardWidth = (listDimensions.containerWidth - totalGapWidth) / columnNum;
        // If not card with padding, then oneCardWidth is same as oneImageWidth
        var oneImgWidth = oneCardWidth - cardWithMarginDimensions;
        return oneImgWidth;
    }();
    var cardSelfDimensions = (0,ProductListWrapper_utils/* useProductCardDimensions */.l)({
        imageWidth: imageWidth
    }).cardSelfDimensions;
    var cardWidth = cardSelfDimensions.cardWidth + cardWithMarginDimensions;
    // const canFitColumns = cardWidth * columnNum <= listDimensions.containerWidth;
    var canFitColumns = cardWidth - gaps.rowGap * columnNum <= listDimensions.containerWidth;
    var snackbarMethods = {
        openSnackbar: function(config) {
            return setSnackbarConfig((0,_object_spread/* default */.Z)({
                open: true
            }, config));
        },
        hideSnackbar: function() {
            return snackbarConfig.open && setSnackbarConfig(function(data) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                    open: false
                });
            });
        }
    };
    var renderProductCard = (0,react.useCallback)(function(index, listItem) {
        var data = listItem;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                showCustomProductCard ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard, {
                    productData: data,
                    itemIndex: index,
                    onItemClick: onItemClick,
                    configs: {
                        cardWrapperConfigs: cardWrapperConfigs,
                        isMobile: isMobile,
                        dimensions: cardSelfDimensions,
                        snackbarMethods: snackbarMethods
                    }
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(OldCardComponent, (0,_object_spread/* default */.Z)({
                    data: data,
                    id: "".concat(data.name, "-").concat(data.id),
                    onItemClick: function() {
                        return onItemClick(data);
                    }
                }, oldCardConfigs)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MobileDsAds */.N1, {
                    data: data
                })
            ]
        }, "items-card-" + data.id);
    }, [
        cardSelfDimensions
    ]);
    if (renderType === "virtualised-grid") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualisedList, {
            ref: virtuosoGridRef,
            listData: productList,
            renderProductCard: renderProductCard,
            virtualisationContainerStyle: {},
            itemsRenderConfig: {
                columnCount: canFitColumns ? columnNum : columnNum - 1,
                columnGap: gaps.columnGap,
                rowGap: gaps.rowGap
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        ref: productItemContainerRef,
        className: classnames_default()("newProductListingWrapper ", renderType === "grid" ? "tw-grid tw-justify-center tw-justify-items-center" : "no-scrollbar tw-flex tw-overflow-auto", customClass),
        style: {
            gridTemplateColumns: "repeat(".concat(canFitColumns ? columnNum : columnNum - 1, ", ").concat(isMobile ? cardWidth > 0 ? "minmax(10px, ".concat(cardWidth, "px)") : "1fr" : "minmax(10px, ".concat(showCustomProductCard || calculateSelfDimensions ? cardWidth : 220, "px)"), ")"),
            columnGap: "".concat(gaps.columnGap, "px"),
            rowGap: "".concat(gaps.rowGap, "px")
        },
        children: [
            (productList === null || productList === void 0 ? void 0 : productList.length) ? productList.map(function(data, index) {
                return renderProductCard(index, data);
            }) : !hideLoaderSkeleton && skeletonCount && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: new Array(skeletonCount).fill(0).map(function(_, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListWrapper_Card, {
                        skeleton: true,
                        skeletonImage: constants/* CARD_SKELETON */.wv
                    }, index);
                })
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Snackbar/* CustomizedSnackbar */.y, {
                config: (0,_object_spread/* default */.Z)({}, snackbarConfig),
                handleSnackbarClose: function() {
                    return setSnackbarConfig(function(x) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, x), {
                            open: false
                        });
                    });
                }
            })
        ]
    });
});


/***/ }),

/***/ 68464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* reexport safe */ _ProductListWrapper__WEBPACK_IMPORTED_MODULE_0__.X; }
/* harmony export */ });
/* harmony import */ var _ProductListWrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39996);



/***/ }),

/***/ 2386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useProductCardElements; },
/* harmony export */   "l": function() { return /* binding */ useProductCardDimensions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17502);




var MAX_CARD_WIDTH = 450;
// const MIN_CARD_WIDTH = 200;
var MAX_CARD_HEIGHT = 450;
function useProductCardElements() {
    var ref, ref1;
    var ref2 = (0,src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_1__/* .useWidgetDndContextData */ .KX)(), globalStyle = ref2.widgetContextState.globalStyle;
    var ref3 = (globalStyle === null || globalStyle === void 0 ? void 0 : globalStyle.productCard) || {
        infoList: [],
        isEnabled: false
    }, infoList = ref3.infoList, isProductCardEnabled = ref3.isEnabled;
    var imageElement = infoList === null || infoList === void 0 ? void 0 : infoList.find(function(item) {
        return item.type === "image";
    });
    var layoutElement = infoList === null || infoList === void 0 ? void 0 : infoList.find(function(item) {
        return item.type === "layout";
    });
    return {
        isProductCardEnabled: isProductCardEnabled,
        layoutElement: layoutElement,
        imageElement: imageElement,
        infoList: infoList,
        aspectRatio: (imageElement === null || imageElement === void 0 ? void 0 : (ref = imageElement.config) === null || ref === void 0 ? void 0 : ref.aspectRatio) || (imageElement === null || imageElement === void 0 ? void 0 : (ref1 = imageElement.config) === null || ref1 === void 0 ? void 0 : ref1.aspectRation)
    };
}
function useProductCardDimensions(param) {
    var imageWidth = param.imageWidth;
    var aspectRatio = useProductCardElements().aspectRatio;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        cardHeight: 0,
        cardWidth: 0
    }), cardSelfDimensions = ref[0], setCardSelfDimensions = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (aspectRatio) {
            var aspectRatios = function() {
                var ratio = (aspectRatio === null || aspectRatio === void 0 ? void 0 : aspectRatio.split(":")) || [
                    1,
                    1
                ];
                return {
                    heightMultiplier: +ratio[1],
                    widthMultiplier: +ratio[0]
                };
            }();
            if (imageWidth) {
                var calculatedCardWidth = imageWidth > MAX_CARD_WIDTH ? MAX_CARD_WIDTH : //   ? MIN_CARD_WIDTH
                imageWidth;
                var calculatedCardHeight = calculatedCardWidth * (aspectRatios.heightMultiplier / aspectRatios.widthMultiplier);
                if (calculatedCardHeight > MAX_CARD_HEIGHT) {
                    calculatedCardHeight = MAX_CARD_HEIGHT;
                    calculatedCardWidth = calculatedCardHeight * (aspectRatios.widthMultiplier / aspectRatios.heightMultiplier);
                }
                setCardSelfDimensions(function(data) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data), {
                        cardWidth: calculatedCardWidth,
                        cardHeight: calculatedCardHeight
                    });
                });
            }
        }
    }, [
        imageWidth,
        aspectRatio
    ]);
    return {
        cardSelfDimensions: cardSelfDimensions
    };
}


/***/ }),

/***/ 85810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ CustomizedSnackbar; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Snackbar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26379);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(40416);
/* harmony import */ var _assets_svgExports_TickFill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72084);
/* harmony import */ var src_hooks_useGetDeviceType__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62946);






// eslint-disable-next-line import/named

// eslint-disable-next-line import/named



function CustomizedSnackbar(param) {
    var config = param.config, _autoHideDuration = param.autoHideDuration, autoHideDuration = _autoHideDuration === void 0 ? 4500 : _autoHideDuration, handleSnackbarClose = param.handleSnackbarClose;
    var isMobile = (0,src_hooks_useGetDeviceType__WEBPACK_IMPORTED_MODULE_3__/* .useGetDeviceType */ .n)().isMobile;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState({
        open: false,
        message: "",
        vertical: "top",
        horizontal: "right",
        type: "success"
    }), 2), state = ref[0], setState = ref[1];
    var vertical = state.vertical, horizontal = state.horizontal;
    var open = config.open, message = config.message;
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        setState((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state, config));
    }, [
        config
    ]);
    var icon = function() {
        switch(state.type){
            case "success":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_TickFill__WEBPACK_IMPORTED_MODULE_2__/* .TickFill */ .v, {
                    width: 17,
                    height: 17,
                    color: "#32B272"
                });
            default:
                return null;
        }
    }();
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Snackbar__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        sx: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, horizontal === "center" && isMobile ? {
            left: "10% !important",
            right: "10% !important"
        } : {}), (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, "& .".concat(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"].root */ .Z.root), {
            minWidth: "auto",
            padding: "0px 0px"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, "& .".concat(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"].message */ .Z.message), {
            width: "100%",
            padding: "15px 20px",
            borderRadius: "6px",
            backgroundColor: "#111C36",
            boxShadow: "0px 4px 4px 0px #00000040"
        }), _obj)),
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        open: open,
        onClose: handleSnackbarClose,
        message: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "tw-flex tw-items-center tw-justify-center tw-gap-[8px]",
            children: [
                icon,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: " tw-m-0 tw-font-inter ",
                    children: message
                })
            ]
        })
    }, vertical + horizontal);
}


/***/ }),

/***/ 80058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ useItemClick; }
});

// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
;// CONCATENATED MODULE: ./src/utils/storeProductClickedDetails.js

function storeProductClickedDetails() {
    var expiresAt = new Date(new Date().getTime() + 30000);
    var sessionObject = {
        expiresAt: expiresAt,
        itemClickedData: {
            CLICKED_ITEM_X_OFFSET: scrollX,
            CLICKED_ITEM_Y_OFFSET: scrollY
        }
    };
    sessionStorage.setItem(constants/* CLICKED_ITEM_OBJ */.uI, JSON.stringify(sessionObject));
}

// EXTERNAL MODULE: ./src/utils/canShowPDPSystem.js
var canShowPDPSystem = __webpack_require__(13051);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(44541);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
;// CONCATENATED MODULE: ./src/hooks/useItemClick.js







function useItemClick() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var storeData = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    /**
   * to go to product description page, special characters are not allowed.
   * using regex to remove all special characters with '-'
   * @param {*} item
   * @param {*} e
   */ var onItemClick = function(item) {
        var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, openInNewTab = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        storeProductClickedDetails();
        e && (e === null || e === void 0 ? void 0 : e.stopPropagation());
        sessionStorage.setItem(constants/* CLICKED_ITEM_X_OFFSET */.AB, scrollX);
        sessionStorage.setItem(constants/* CLICKED_ITEM_Y_OFFSET */.WR, scrollY);
        /** if color is there push with color in query params */ if (item === null || item === void 0 ? void 0 : item.color) {
            var ref;
            router_default().push((0,routes.getRoute)("".concat(routes.PATH.productDescription(item.id, item.name.replace(constants/* PROD_NAME_REPLACE_REGEX */.Ds, "-")), "?color=").concat(item === null || item === void 0 ? void 0 : item.color), storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
        } else {
            var ref1, ref2;
            var link = (0,routes.getRoute)(routes.PATH.productDescription(item.id, item.name.replace(constants/* PROD_NAME_REPLACE_REGEX */.Ds, "-")), storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain);
            (0,canShowPDPSystem/* canShowPDPSystem */.R)(storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.theme) === null || ref2 === void 0 ? void 0 : ref2.theme_class) ? !openInNewTab ? router_default().push(link) : window.open(link, "_blank") : dispatch((0,catalog/* savePDPData */.zP)({
                visible: true,
                product: item
            }));
        }
    };
    var getLink = function(item) {
        var ref;
        if (!item) {
            return;
        }
        var productBaseLink = routes.PATH.productDescription(item.id, (ref = item.name) === null || ref === void 0 ? void 0 : ref.replace(constants/* PROD_NAME_REPLACE_REGEX */.Ds, "-"));
        /** if color is there push with color in query params */ var link = "";
        if (item === null || item === void 0 ? void 0 : item.color) {
            var ref1;
            link = (0,routes.getRoute)("".concat(productBaseLink, "?color=").concat(item === null || item === void 0 ? void 0 : item.color), storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain);
        } else {
            var ref2;
            if ((0,canShowPDPSystem/* canShowPDPSystem */.R)(storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.theme) === null || ref2 === void 0 ? void 0 : ref2.theme_class)) {
                var ref3;
                link = (0,routes.getRoute)(productBaseLink, storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.store_info) === null || ref3 === void 0 ? void 0 : ref3.domain);
            }
        }
        return link || "";
    };
    return [
        onItemClick,
        getLink
    ];
}


/***/ }),

/***/ 13051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ canShowPDPSystem; }
/* harmony export */ });
var canShowPDPSystem = function(themeVar) {
    switch(themeVar){
        case 1:
            return true;
        case 2:
            return true;
        case 3:
            return false;
        case 4:
            return false;
        default:
            return true;
    }
};


/***/ }),

/***/ 95218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ removeDsAdsRouteLink; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13886);

function removeDsAdsRouteLink() {
    window.open(_constants__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECT_DS_ADS_LINK.COMMON_REDIRECTION_LINK */ .gr.COMMON_REDIRECTION_LINK, "_blank");
}


/***/ }),

/***/ 87243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ scrollOnPageLoad; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13886);
/**
 * Checks whether sessionStorage has an item clicked data stored.
 * Then verifies whether the duration between clicked time and returning
 * back to home screen is > 30seconds. Then returns whether session storage
 * contains x and y coordinates of clicked item from PDP section.
 * If the session has those, then return the coordinates else return false.
 * This function is currently being used by Home component on page load.
 */ 
function scrollOnPageLoad() {
    var currTime = new Date();
    var sessionObject = JSON.parse(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .CLICKED_ITEM_OBJ */ .uI));
    if (sessionObject) {
        var expirationTime = sessionObject === null || sessionObject === void 0 ? void 0 : sessionObject.expiresAt;
        if (expirationTime && Date.parse(currTime) < Date.parse(expirationTime)) {
            var ref, ref1;
            var y_offset = sessionObject === null || sessionObject === void 0 ? void 0 : (ref = sessionObject.itemClickedData) === null || ref === void 0 ? void 0 : ref.CLICKED_ITEM_Y_OFFSET;
            var x_offset = sessionObject === null || sessionObject === void 0 ? void 0 : (ref1 = sessionObject.itemClickedData) === null || ref1 === void 0 ? void 0 : ref1.CLICKED_ITEM_X_OFFSET;
            if (y_offset && y_offset !== 0) {
                return {
                    toScroll: true,
                    x_scroll: x_offset,
                    y_scroll: y_offset
                };
            }
        } else {
            sessionStorage.removeItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .CLICKED_ITEM_OBJ */ .uI);
        }
    }
    return {
        toScroll: false
    };
}


/***/ })

}]);